import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useLocation } from 'react-router-dom'; 
import axios from "axios";
import { useLoading } from "../contexts/LoadingContext"; 
import Header_packages from "../components/Header_packages";

const Packages = () => {
  const [subscriptions, setSubscriptions] = useState([]); // All subscriptions
  const [loading, setLoading] = useState(true); // General loading state // Loading state for each subscription
  const { isLoading, setIsLoading } = useLoading();
  const location = useLocation();
  const { pid } = location.state || {}; 

  const decryptedMsisdn = sessionStorage.getItem("decryptedMsisdn") || "";

  useEffect(() => {
    const fetchSubscriptions = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post(
          "https://bankalfalah.webddocsystems.com/smosa.php/Allservices",
          { msisdn: decryptedMsisdn },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic RE9UVXNlcm5hbWUxOkRPVFBhc3MyMTNAIQ==",
              PartnerId: "partner-a5d477b9-c77c-48d5-b9d0-df2d71370680",
              Accept: "application/json",
            },
          }
        );

        if (response.status === 200 && response.data.resultCode === "0") {
          setSubscriptions(response.data.data || []);
        } else {
          console.error("Unexpected response structure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching subscriptions:", error);
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    };

    fetchSubscriptions();
  }, [setIsLoading]);



  return (
    <>
      <Header_packages title="My Packages" />
      <Container className="mt-5">
        <Row style={{ marginBottom: "130px", marginTop: "20px" }}>
          {loading ? (
            <p className="text-center">Loading...</p>
          ) : subscriptions.length > 0 ? (
            subscriptions.map((subscription, index) => (
              <Col xs={12} md={8} lg={6} className="mx-auto" key={index}>
                <Card className="shadow border-0 rounded-lg mb-4">
                  <Card.Body>
                    <div className="d-flex justify-content-between mb-3">
                      <div>
                        <p className="mb-1 heading">Service Name:</p>
                        <p className="mb-1">{subscription.serviceName}</p>
                        <p className="mb-1 heading">Subscription Date:</p>
                        <p className="mb-1">{subscription.subscriptionDate}</p>
                      </div>
                      <div>
                        <p className="mb-1 heading">Next Renewal Date:</p>
                        <p className="mb-1">
                          {subscription.nextRenewalDate || "N/A"}
                        </p>
                        <p className="mb-1 heading">Bundle Expiry Date:</p>
                        <p className="mb-1">
                          {subscription.bundleExpiryDate || "N/A"}
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))
          ) : (
            <p className="text-center">No active subscriptions available.</p>
          )}
        </Row>
      </Container>
    </>
  );
};

export default Packages;
